import React, { useState } from "react";
import { motion } from "framer-motion";
import ForestBackdrop from "../ForestBackdrop/ForestBackdrop";
import styles from "./QuizStep.module.css";

const KEY_LETTERS = ["A", "B", "C", "D", "E", "F"];

export default function QuizStep({ data, onSubmit, isSubmitting }) {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);

  const totalQuestions = data?.questions?.length || 0;
  const currentQuestion = data?.questions?.[currentQuestionIndex];

  const handleAnswerSelect = (answerIndex) => {
    setSelectedAnswers({
      ...selectedAnswers,
      [currentQuestionIndex]: answerIndex,
    });
  };

  const handleNext = () => {
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setShowResults(true);
    }
  };

  if (showResults) {
    const score = Object.keys(selectedAnswers).reduce((acc, index) => {
      const question = data.questions[index];
      const selectedAnswerIndex = selectedAnswers[index];
      if (question.answers[selectedAnswerIndex]?.isCorrect) return acc + 1;
      return acc;
    }, 0);
    const percentage = Math.round((score / totalQuestions) * 100);

    return (
      <ForestBackdrop>
        <div className={styles.quizContainer}>
          <div className={styles.resultsScreen}>
            <h2>Quiz complete</h2>
            <p>Your score</p>
            <div className={styles.scoreDisplay}>{percentage}%</div>
            <p>
              {score} of {totalQuestions} correct
            </p>
            <button
              type="button"
              className={styles.submitButton}
              onClick={() => onSubmit(percentage)}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving…" : "Save &amp; continue"}
            </button>
          </div>
        </div>
      </ForestBackdrop>
    );
  }

  if (!currentQuestion) return null;

  return (
    <ForestBackdrop>
      <div className={styles.quizContainer}>
        <div className={styles.questionHeader}>
          Question {currentQuestionIndex + 1} of {totalQuestions}
        </div>
        <h2 className={styles.questionText}>{currentQuestion.questionText}</h2>

        <div className={styles.answersGrid}>
          {currentQuestion.answers.map((answer, index) => (
            <motion.button
              key={index}
              type="button"
              className={`${styles.answerButton} ${
                selectedAnswers[currentQuestionIndex] === index
                  ? styles.selected
                  : ""
              }`}
              onClick={() => handleAnswerSelect(index)}
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
            >
              <span className={styles.answerKey}>
                {KEY_LETTERS[index] || String(index + 1)}
              </span>
              <span style={{ flex: 1 }}>{answer.answerText}</span>
            </motion.button>
          ))}
        </div>

        <div className={styles.navigation}>
          <button
            type="button"
            className={styles.nextButton}
            onClick={handleNext}
            disabled={selectedAnswers[currentQuestionIndex] === undefined}
          >
            {currentQuestionIndex < totalQuestions - 1
              ? "Next question"
              : "Finish quiz"}
          </button>
        </div>
      </div>
    </ForestBackdrop>
  );
}
